import {useEffect, type FC} from "react";
import {useDrop, type DropTargetMonitor} from "react-dnd";
import {NativeTypes} from "react-dnd-html5-backend";

import {ALLOWED_FILE_TYPES} from "../image-attach/constants.ts";

export interface TargetBoxProps {
    onDrop: (file: any) => void;
    onOver: (isOver: boolean) => void;
    children: React.ReactNode;
    // Optional test identifier for targeting in tests, gets mapped to data-testid attribute
    testId?: string;
}

export const DragAndDropFileTarget: FC<TargetBoxProps> = (props) => {
    const {onDrop, onOver, children, testId} = props;

    const isFile = (input) => "File" in window && input instanceof File;

    const [{isOver}, drop] = useDrop(
        () => ({
            accept: [NativeTypes.FILE],
            drop(item: {files: any[]}) {
                if (onDrop && isFile(item.files[0])) {
                    onDrop(item.files[0]);
                }
            },
            canDrop(item: any) {
                if (
                    item.files?.length === 1 &&
                    ALLOWED_FILE_TYPES.includes(item.files[0].type)
                ) {
                    return true;
                }
                return false;
            },
            hover(item: any) {},
            collect: (monitor: DropTargetMonitor) => {
                return {
                    isOver: monitor.isOver(),
                    canDrop: monitor.canDrop(),
                };
            },
        }),
        [props],
    );

    useEffect(() => {
        onOver(isOver);
    }, [isOver, onOver]);

    // can pass canDrop and isOver to children if we want to render differently with either state
    return (
        <div ref={drop} data-testid={testId}>
            {children}
        </div>
    );
};
